import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, ViewEncapsulation, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnterLeaveFadeInOutAnimation } from '@nha/components/animations';
import { CommonModule } from '@angular/common';
import { ScrollIfDirective } from '@nha/directives/scroll-if/scroll-if.directive';
import { NHATestDirective } from '@nha/directives/test/test.directive';
import { TemplateFunctionPipe } from '@nha/pipes/template-function.pipe';
import { MatSliderModule } from '@angular/material/slider';
import { IFilterItem } from '@nha/components';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FilterBaseSlideComponent } from '../../classes/filter-base-slide-component.class';

@Component({
	selector: 'nha-filter',
	templateUrl: './filter.component.html',
	styleUrls: ['./filter.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [EnterLeaveFadeInOutAnimation],
	imports: [
		NHATestDirective,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		ScrollIfDirective,
		TemplateFunctionPipe,
		MatSliderModule,
		MatSlideToggleModule,
		MatButtonModule,
		MatIconModule,
		MatInputModule,
		MatFormFieldModule
	]
})
export class NHAFilterComponent extends FilterBaseSlideComponent {
	protected readonly _cdr: ChangeDetectorRef;

	expanded = computed(() => this.filter().expanded);

	constructor() {
		const _cdr = inject(ChangeDetectorRef);

		super(_cdr);
	
		this._cdr = _cdr;
	}

	toggleExpand(): void {
		this.filterState.toggleExpanded(this.key(), this.filterKey());
	}

	getFilterIcon(item: IFilterItem): string {
		if (this.filter().multiple) {
			return item.selected ? 'check_box' : 'check_box_outline_blank';
		}
		return item.selected ? 'radio_button_checked' : 'radio_button_unchecked';
	}
}
